import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

interface UserGroupsResult {
  groups: string[];
  loading: boolean;
}

export function useUserGroups(): UserGroupsResult {
  const [groups, setGroups] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAuthSession()
      .then((session) => {
        const payload = session.tokens?.idToken?.payload;
        const g = (payload?.['cognito:groups'] as string[] | undefined) || [];
        setGroups(g);
      })
      .catch(() => setGroups([]))
      .finally(() => setLoading(false));
  }, []);

  return { groups, loading };
}
